<template>
    <el-menu class="left-sidebar-menu" @select="handleSelect" :default-active="$route.path">
        <el-menu-item index="/app/list">
            <i class="el-icon-menu app-store"></i>
            <span slot="title">{{ $t("title.appList")}}</span>
        </el-menu-item>
        <el-menu-item index="/ad/list">
            <i class="el-icon-document ad-icon"></i>
            <span slot="title">{{ $t("title.adsenseList")}}</span>
        </el-menu-item>
  </el-menu>
</template>
<script>
    export default {
        methods: {
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
        }
    }
</script>

<style>
.el-menu-item .app-store.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/app-store-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item.is-active .app-store.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/app-store-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item .ad-icon.el-icon-document:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/ad-list-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item.is-active .ad-icon.el-icon-document:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../assets/img/ad-list-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}

</style>
